import React from "react";
import { colors } from "@/assets/themes";
import type { LabelProps } from "../types";

const Label = ({ children, className }: LabelProps) => (
  <p
    className={`d-flex justify-content-end mb-0 text-right align-items-center ${className}`}
    style={{ color: colors.muted }}
  >
    {children}
  </p>
);

export default Label;
